/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AddonsImport } from './routes/addons'
import { Route as FilesRouteImport } from './routes/files/route'
import { Route as ExpensesRouteImport } from './routes/expenses/route'
import { Route as DonationsRouteImport } from './routes/donations/route'
import { Route as CampaignsRouteImport } from './routes/campaigns/route'
import { Route as IndexImport } from './routes/index'
import { Route as FilesIndexImport } from './routes/files/index'
import { Route as ExpensesIndexImport } from './routes/expenses/index'
import { Route as DonationsIndexImport } from './routes/donations/index'
import { Route as ContactsIndexImport } from './routes/contacts/index'
import { Route as CampaignsIndexImport } from './routes/campaigns/index'
import { Route as SettingsLayoutImport } from './routes/settings/_layout'
import { Route as DonationsCategoriesImport } from './routes/donations/categories'
import { Route as ContactsTasksImport } from './routes/contacts/tasks'
import { Route as ContactsTaskTypesImport } from './routes/contacts/task-types'
import { Route as ContactsFixAndMergeImport } from './routes/contacts/fix-and-merge'
import { Route as ContactsContactIdRouteImport } from './routes/contacts/$contactId_/route'
import { Route as SettingsLayoutIndexImport } from './routes/settings/_layout.index'
import { Route as EmailsTemplatesIndexImport } from './routes/emails/templates/index'
import { Route as EmailsScheduledIndexImport } from './routes/emails/scheduled/index'
import { Route as EmailsDraftsIndexImport } from './routes/emails/drafts/index'
import { Route as EmailsDesignsIndexImport } from './routes/emails/designs/index'
import { Route as EmailssentIndexImport } from './routes/emails/(sent)/index'
import { Route as DonationsDonationIdIndexImport } from './routes/donations/$donationId/index'
import { Route as ContactsGroupsIndexImport } from './routes/contacts/groups/index'
import { Route as ContactsContactIdIndexImport } from './routes/contacts/$contactId_/index'
import { Route as SettingsLayoutEmailsImport } from './routes/settings/_layout.emails'
import { Route as SettingsLayoutBillingImport } from './routes/settings/_layout.billing'
import { Route as EmailsTemplatesTemplateIdImport } from './routes/emails/templates/$templateId'
import { Route as EmailsScheduledScheduledIdImport } from './routes/emails/scheduled/$scheduledId'
import { Route as EmailsDesignsDesignIdImport } from './routes/emails/designs/$designId'
import { Route as ContactsGroupsGroupIdImport } from './routes/contacts/groups/$groupId'
import { Route as ContactsContactIdFilesImport } from './routes/contacts/$contactId_/files'
import { Route as ContactsContactIdExpensesImport } from './routes/contacts/$contactId_/expenses'
import { Route as ContactsContactIdEmailsImport } from './routes/contacts/$contactId_/emails'
import { Route as ContactsContactIdDonationsImport } from './routes/contacts/$contactId_/donations'
import { Route as ContactsContactIdEditImport } from './routes/contacts/$contactId.edit'
import { Route as EmailssentEmailIdRouteImport } from './routes/emails/(sent)/$emailId/route'
import { Route as EmailsDraftsDraftIdIndexImport } from './routes/emails/drafts/$draftId/index'
import { Route as EmailssentEmailIdIndexImport } from './routes/emails/(sent)/$emailId/index'
import { Route as EmailsDraftsDraftIdEditImport } from './routes/emails/drafts/$draftId/edit'
import { Route as EmailssentEmailIdStatTypeImport } from './routes/emails/(sent)/$emailId/$statType'

// Create Virtual Routes

const SettingsImport = createFileRoute('/settings')()

// Create/Update Routes

const SettingsRoute = SettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const AddonsRoute = AddonsImport.update({
  id: '/addons',
  path: '/addons',
  getParentRoute: () => rootRoute,
} as any)

const FilesRouteRoute = FilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => rootRoute,
} as any)

const ExpensesRouteRoute = ExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => rootRoute,
} as any)

const DonationsRouteRoute = DonationsRouteImport.update({
  id: '/donations',
  path: '/donations',
  getParentRoute: () => rootRoute,
} as any)

const CampaignsRouteRoute = CampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const FilesIndexRoute = FilesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FilesRouteRoute,
} as any)

const ExpensesIndexRoute = ExpensesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExpensesRouteRoute,
} as any)

const DonationsIndexRoute = DonationsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DonationsRouteRoute,
} as any)

const ContactsIndexRoute = ContactsIndexImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => rootRoute,
} as any)

const CampaignsIndexRoute = CampaignsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CampaignsRouteRoute,
} as any)

const SettingsLayoutRoute = SettingsLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => SettingsRoute,
} as any)

const DonationsCategoriesRoute = DonationsCategoriesImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => DonationsRouteRoute,
} as any)

const ContactsTasksRoute = ContactsTasksImport.update({
  id: '/contacts/tasks',
  path: '/contacts/tasks',
  getParentRoute: () => rootRoute,
} as any)

const ContactsTaskTypesRoute = ContactsTaskTypesImport.update({
  id: '/contacts/task-types',
  path: '/contacts/task-types',
  getParentRoute: () => rootRoute,
} as any)

const ContactsFixAndMergeRoute = ContactsFixAndMergeImport.update({
  id: '/contacts/fix-and-merge',
  path: '/contacts/fix-and-merge',
  getParentRoute: () => rootRoute,
} as any)

const ContactsContactIdRouteRoute = ContactsContactIdRouteImport.update({
  id: '/contacts/$contactId_',
  path: '/contacts/$contactId',
  getParentRoute: () => rootRoute,
} as any)

const SettingsLayoutIndexRoute = SettingsLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsLayoutRoute,
} as any)

const EmailsTemplatesIndexRoute = EmailsTemplatesIndexImport.update({
  id: '/emails/templates/',
  path: '/emails/templates/',
  getParentRoute: () => rootRoute,
} as any)

const EmailsScheduledIndexRoute = EmailsScheduledIndexImport.update({
  id: '/emails/scheduled/',
  path: '/emails/scheduled/',
  getParentRoute: () => rootRoute,
} as any)

const EmailsDraftsIndexRoute = EmailsDraftsIndexImport.update({
  id: '/emails/drafts/',
  path: '/emails/drafts/',
  getParentRoute: () => rootRoute,
} as any)

const EmailsDesignsIndexRoute = EmailsDesignsIndexImport.update({
  id: '/emails/designs/',
  path: '/emails/designs/',
  getParentRoute: () => rootRoute,
} as any)

const EmailssentIndexRoute = EmailssentIndexImport.update({
  id: '/emails/(sent)/',
  path: '/emails/',
  getParentRoute: () => rootRoute,
} as any)

const DonationsDonationIdIndexRoute = DonationsDonationIdIndexImport.update({
  id: '/$donationId/',
  path: '/$donationId/',
  getParentRoute: () => DonationsRouteRoute,
} as any)

const ContactsGroupsIndexRoute = ContactsGroupsIndexImport.update({
  id: '/contacts/groups/',
  path: '/contacts/groups/',
  getParentRoute: () => rootRoute,
} as any)

const ContactsContactIdIndexRoute = ContactsContactIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContactsContactIdRouteRoute,
} as any)

const SettingsLayoutEmailsRoute = SettingsLayoutEmailsImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => SettingsLayoutRoute,
} as any)

const SettingsLayoutBillingRoute = SettingsLayoutBillingImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => SettingsLayoutRoute,
} as any)

const EmailsTemplatesTemplateIdRoute = EmailsTemplatesTemplateIdImport.update({
  id: '/emails/templates/$templateId',
  path: '/emails/templates/$templateId',
  getParentRoute: () => rootRoute,
} as any)

const EmailsScheduledScheduledIdRoute = EmailsScheduledScheduledIdImport.update(
  {
    id: '/emails/scheduled/$scheduledId',
    path: '/emails/scheduled/$scheduledId',
    getParentRoute: () => rootRoute,
  } as any,
)

const EmailsDesignsDesignIdRoute = EmailsDesignsDesignIdImport.update({
  id: '/emails/designs/$designId',
  path: '/emails/designs/$designId',
  getParentRoute: () => rootRoute,
} as any)

const ContactsGroupsGroupIdRoute = ContactsGroupsGroupIdImport.update({
  id: '/contacts/groups/$groupId',
  path: '/contacts/groups/$groupId',
  getParentRoute: () => rootRoute,
} as any)

const ContactsContactIdFilesRoute = ContactsContactIdFilesImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => ContactsContactIdRouteRoute,
} as any)

const ContactsContactIdExpensesRoute = ContactsContactIdExpensesImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => ContactsContactIdRouteRoute,
} as any)

const ContactsContactIdEmailsRoute = ContactsContactIdEmailsImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => ContactsContactIdRouteRoute,
} as any)

const ContactsContactIdDonationsRoute = ContactsContactIdDonationsImport.update(
  {
    id: '/donations',
    path: '/donations',
    getParentRoute: () => ContactsContactIdRouteRoute,
  } as any,
)

const ContactsContactIdEditRoute = ContactsContactIdEditImport.update({
  id: '/contacts/$contactId/edit',
  path: '/contacts/$contactId/edit',
  getParentRoute: () => rootRoute,
} as any)

const EmailssentEmailIdRouteRoute = EmailssentEmailIdRouteImport.update({
  id: '/emails/(sent)/$emailId',
  path: '/emails/$emailId',
  getParentRoute: () => rootRoute,
} as any)

const EmailsDraftsDraftIdIndexRoute = EmailsDraftsDraftIdIndexImport.update({
  id: '/emails/drafts/$draftId/',
  path: '/emails/drafts/$draftId/',
  getParentRoute: () => rootRoute,
} as any)

const EmailssentEmailIdIndexRoute = EmailssentEmailIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EmailssentEmailIdRouteRoute,
} as any)

const EmailsDraftsDraftIdEditRoute = EmailsDraftsDraftIdEditImport.update({
  id: '/emails/drafts/$draftId/edit',
  path: '/emails/drafts/$draftId/edit',
  getParentRoute: () => rootRoute,
} as any)

const EmailssentEmailIdStatTypeRoute = EmailssentEmailIdStatTypeImport.update({
  id: '/$statType',
  path: '/$statType',
  getParentRoute: () => EmailssentEmailIdRouteRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/campaigns': {
      id: '/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof CampaignsRouteImport
      parentRoute: typeof rootRoute
    }
    '/donations': {
      id: '/donations'
      path: '/donations'
      fullPath: '/donations'
      preLoaderRoute: typeof DonationsRouteImport
      parentRoute: typeof rootRoute
    }
    '/expenses': {
      id: '/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof ExpensesRouteImport
      parentRoute: typeof rootRoute
    }
    '/files': {
      id: '/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof FilesRouteImport
      parentRoute: typeof rootRoute
    }
    '/addons': {
      id: '/addons'
      path: '/addons'
      fullPath: '/addons'
      preLoaderRoute: typeof AddonsImport
      parentRoute: typeof rootRoute
    }
    '/contacts/$contactId_': {
      id: '/contacts/$contactId_'
      path: '/contacts/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof ContactsContactIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/contacts/fix-and-merge': {
      id: '/contacts/fix-and-merge'
      path: '/contacts/fix-and-merge'
      fullPath: '/contacts/fix-and-merge'
      preLoaderRoute: typeof ContactsFixAndMergeImport
      parentRoute: typeof rootRoute
    }
    '/contacts/task-types': {
      id: '/contacts/task-types'
      path: '/contacts/task-types'
      fullPath: '/contacts/task-types'
      preLoaderRoute: typeof ContactsTaskTypesImport
      parentRoute: typeof rootRoute
    }
    '/contacts/tasks': {
      id: '/contacts/tasks'
      path: '/contacts/tasks'
      fullPath: '/contacts/tasks'
      preLoaderRoute: typeof ContactsTasksImport
      parentRoute: typeof rootRoute
    }
    '/donations/categories': {
      id: '/donations/categories'
      path: '/categories'
      fullPath: '/donations/categories'
      preLoaderRoute: typeof DonationsCategoriesImport
      parentRoute: typeof DonationsRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/settings/_layout': {
      id: '/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsLayoutImport
      parentRoute: typeof SettingsRoute
    }
    '/campaigns/': {
      id: '/campaigns/'
      path: '/'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof CampaignsIndexImport
      parentRoute: typeof CampaignsRouteImport
    }
    '/contacts/': {
      id: '/contacts/'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof ContactsIndexImport
      parentRoute: typeof rootRoute
    }
    '/donations/': {
      id: '/donations/'
      path: '/'
      fullPath: '/donations/'
      preLoaderRoute: typeof DonationsIndexImport
      parentRoute: typeof DonationsRouteImport
    }
    '/expenses/': {
      id: '/expenses/'
      path: '/'
      fullPath: '/expenses/'
      preLoaderRoute: typeof ExpensesIndexImport
      parentRoute: typeof ExpensesRouteImport
    }
    '/files/': {
      id: '/files/'
      path: '/'
      fullPath: '/files/'
      preLoaderRoute: typeof FilesIndexImport
      parentRoute: typeof FilesRouteImport
    }
    '/emails/(sent)/$emailId': {
      id: '/emails/(sent)/$emailId'
      path: '/emails/$emailId'
      fullPath: '/emails/$emailId'
      preLoaderRoute: typeof EmailssentEmailIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/contacts/$contactId/edit': {
      id: '/contacts/$contactId/edit'
      path: '/contacts/$contactId/edit'
      fullPath: '/contacts/$contactId/edit'
      preLoaderRoute: typeof ContactsContactIdEditImport
      parentRoute: typeof rootRoute
    }
    '/contacts/$contactId_/donations': {
      id: '/contacts/$contactId_/donations'
      path: '/donations'
      fullPath: '/contacts/$contactId/donations'
      preLoaderRoute: typeof ContactsContactIdDonationsImport
      parentRoute: typeof ContactsContactIdRouteImport
    }
    '/contacts/$contactId_/emails': {
      id: '/contacts/$contactId_/emails'
      path: '/emails'
      fullPath: '/contacts/$contactId/emails'
      preLoaderRoute: typeof ContactsContactIdEmailsImport
      parentRoute: typeof ContactsContactIdRouteImport
    }
    '/contacts/$contactId_/expenses': {
      id: '/contacts/$contactId_/expenses'
      path: '/expenses'
      fullPath: '/contacts/$contactId/expenses'
      preLoaderRoute: typeof ContactsContactIdExpensesImport
      parentRoute: typeof ContactsContactIdRouteImport
    }
    '/contacts/$contactId_/files': {
      id: '/contacts/$contactId_/files'
      path: '/files'
      fullPath: '/contacts/$contactId/files'
      preLoaderRoute: typeof ContactsContactIdFilesImport
      parentRoute: typeof ContactsContactIdRouteImport
    }
    '/contacts/groups/$groupId': {
      id: '/contacts/groups/$groupId'
      path: '/contacts/groups/$groupId'
      fullPath: '/contacts/groups/$groupId'
      preLoaderRoute: typeof ContactsGroupsGroupIdImport
      parentRoute: typeof rootRoute
    }
    '/emails/designs/$designId': {
      id: '/emails/designs/$designId'
      path: '/emails/designs/$designId'
      fullPath: '/emails/designs/$designId'
      preLoaderRoute: typeof EmailsDesignsDesignIdImport
      parentRoute: typeof rootRoute
    }
    '/emails/scheduled/$scheduledId': {
      id: '/emails/scheduled/$scheduledId'
      path: '/emails/scheduled/$scheduledId'
      fullPath: '/emails/scheduled/$scheduledId'
      preLoaderRoute: typeof EmailsScheduledScheduledIdImport
      parentRoute: typeof rootRoute
    }
    '/emails/templates/$templateId': {
      id: '/emails/templates/$templateId'
      path: '/emails/templates/$templateId'
      fullPath: '/emails/templates/$templateId'
      preLoaderRoute: typeof EmailsTemplatesTemplateIdImport
      parentRoute: typeof rootRoute
    }
    '/settings/_layout/billing': {
      id: '/settings/_layout/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsLayoutBillingImport
      parentRoute: typeof SettingsLayoutImport
    }
    '/settings/_layout/emails': {
      id: '/settings/_layout/emails'
      path: '/emails'
      fullPath: '/settings/emails'
      preLoaderRoute: typeof SettingsLayoutEmailsImport
      parentRoute: typeof SettingsLayoutImport
    }
    '/contacts/$contactId_/': {
      id: '/contacts/$contactId_/'
      path: '/'
      fullPath: '/contacts/$contactId/'
      preLoaderRoute: typeof ContactsContactIdIndexImport
      parentRoute: typeof ContactsContactIdRouteImport
    }
    '/contacts/groups/': {
      id: '/contacts/groups/'
      path: '/contacts/groups'
      fullPath: '/contacts/groups'
      preLoaderRoute: typeof ContactsGroupsIndexImport
      parentRoute: typeof rootRoute
    }
    '/donations/$donationId/': {
      id: '/donations/$donationId/'
      path: '/$donationId'
      fullPath: '/donations/$donationId'
      preLoaderRoute: typeof DonationsDonationIdIndexImport
      parentRoute: typeof DonationsRouteImport
    }
    '/emails/(sent)/': {
      id: '/emails/(sent)/'
      path: '/emails'
      fullPath: '/emails'
      preLoaderRoute: typeof EmailssentIndexImport
      parentRoute: typeof rootRoute
    }
    '/emails/designs/': {
      id: '/emails/designs/'
      path: '/emails/designs'
      fullPath: '/emails/designs'
      preLoaderRoute: typeof EmailsDesignsIndexImport
      parentRoute: typeof rootRoute
    }
    '/emails/drafts/': {
      id: '/emails/drafts/'
      path: '/emails/drafts'
      fullPath: '/emails/drafts'
      preLoaderRoute: typeof EmailsDraftsIndexImport
      parentRoute: typeof rootRoute
    }
    '/emails/scheduled/': {
      id: '/emails/scheduled/'
      path: '/emails/scheduled'
      fullPath: '/emails/scheduled'
      preLoaderRoute: typeof EmailsScheduledIndexImport
      parentRoute: typeof rootRoute
    }
    '/emails/templates/': {
      id: '/emails/templates/'
      path: '/emails/templates'
      fullPath: '/emails/templates'
      preLoaderRoute: typeof EmailsTemplatesIndexImport
      parentRoute: typeof rootRoute
    }
    '/settings/_layout/': {
      id: '/settings/_layout/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsLayoutIndexImport
      parentRoute: typeof SettingsLayoutImport
    }
    '/emails/(sent)/$emailId/$statType': {
      id: '/emails/(sent)/$emailId/$statType'
      path: '/$statType'
      fullPath: '/emails/$emailId/$statType'
      preLoaderRoute: typeof EmailssentEmailIdStatTypeImport
      parentRoute: typeof EmailssentEmailIdRouteImport
    }
    '/emails/drafts/$draftId/edit': {
      id: '/emails/drafts/$draftId/edit'
      path: '/emails/drafts/$draftId/edit'
      fullPath: '/emails/drafts/$draftId/edit'
      preLoaderRoute: typeof EmailsDraftsDraftIdEditImport
      parentRoute: typeof rootRoute
    }
    '/emails/(sent)/$emailId/': {
      id: '/emails/(sent)/$emailId/'
      path: '/'
      fullPath: '/emails/$emailId/'
      preLoaderRoute: typeof EmailssentEmailIdIndexImport
      parentRoute: typeof EmailssentEmailIdRouteImport
    }
    '/emails/drafts/$draftId/': {
      id: '/emails/drafts/$draftId/'
      path: '/emails/drafts/$draftId'
      fullPath: '/emails/drafts/$draftId'
      preLoaderRoute: typeof EmailsDraftsDraftIdIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

interface CampaignsRouteRouteChildren {
  CampaignsIndexRoute: typeof CampaignsIndexRoute
}

const CampaignsRouteRouteChildren: CampaignsRouteRouteChildren = {
  CampaignsIndexRoute: CampaignsIndexRoute,
}

const CampaignsRouteRouteWithChildren = CampaignsRouteRoute._addFileChildren(
  CampaignsRouteRouteChildren,
)

interface DonationsRouteRouteChildren {
  DonationsCategoriesRoute: typeof DonationsCategoriesRoute
  DonationsIndexRoute: typeof DonationsIndexRoute
  DonationsDonationIdIndexRoute: typeof DonationsDonationIdIndexRoute
}

const DonationsRouteRouteChildren: DonationsRouteRouteChildren = {
  DonationsCategoriesRoute: DonationsCategoriesRoute,
  DonationsIndexRoute: DonationsIndexRoute,
  DonationsDonationIdIndexRoute: DonationsDonationIdIndexRoute,
}

const DonationsRouteRouteWithChildren = DonationsRouteRoute._addFileChildren(
  DonationsRouteRouteChildren,
)

interface ExpensesRouteRouteChildren {
  ExpensesIndexRoute: typeof ExpensesIndexRoute
}

const ExpensesRouteRouteChildren: ExpensesRouteRouteChildren = {
  ExpensesIndexRoute: ExpensesIndexRoute,
}

const ExpensesRouteRouteWithChildren = ExpensesRouteRoute._addFileChildren(
  ExpensesRouteRouteChildren,
)

interface FilesRouteRouteChildren {
  FilesIndexRoute: typeof FilesIndexRoute
}

const FilesRouteRouteChildren: FilesRouteRouteChildren = {
  FilesIndexRoute: FilesIndexRoute,
}

const FilesRouteRouteWithChildren = FilesRouteRoute._addFileChildren(
  FilesRouteRouteChildren,
)

interface ContactsContactIdRouteRouteChildren {
  ContactsContactIdDonationsRoute: typeof ContactsContactIdDonationsRoute
  ContactsContactIdEmailsRoute: typeof ContactsContactIdEmailsRoute
  ContactsContactIdExpensesRoute: typeof ContactsContactIdExpensesRoute
  ContactsContactIdFilesRoute: typeof ContactsContactIdFilesRoute
  ContactsContactIdIndexRoute: typeof ContactsContactIdIndexRoute
}

const ContactsContactIdRouteRouteChildren: ContactsContactIdRouteRouteChildren =
  {
    ContactsContactIdDonationsRoute: ContactsContactIdDonationsRoute,
    ContactsContactIdEmailsRoute: ContactsContactIdEmailsRoute,
    ContactsContactIdExpensesRoute: ContactsContactIdExpensesRoute,
    ContactsContactIdFilesRoute: ContactsContactIdFilesRoute,
    ContactsContactIdIndexRoute: ContactsContactIdIndexRoute,
  }

const ContactsContactIdRouteRouteWithChildren =
  ContactsContactIdRouteRoute._addFileChildren(
    ContactsContactIdRouteRouteChildren,
  )

interface SettingsLayoutRouteChildren {
  SettingsLayoutBillingRoute: typeof SettingsLayoutBillingRoute
  SettingsLayoutEmailsRoute: typeof SettingsLayoutEmailsRoute
  SettingsLayoutIndexRoute: typeof SettingsLayoutIndexRoute
}

const SettingsLayoutRouteChildren: SettingsLayoutRouteChildren = {
  SettingsLayoutBillingRoute: SettingsLayoutBillingRoute,
  SettingsLayoutEmailsRoute: SettingsLayoutEmailsRoute,
  SettingsLayoutIndexRoute: SettingsLayoutIndexRoute,
}

const SettingsLayoutRouteWithChildren = SettingsLayoutRoute._addFileChildren(
  SettingsLayoutRouteChildren,
)

interface SettingsRouteChildren {
  SettingsLayoutRoute: typeof SettingsLayoutRouteWithChildren
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsLayoutRoute: SettingsLayoutRouteWithChildren,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface EmailssentEmailIdRouteRouteChildren {
  EmailssentEmailIdStatTypeRoute: typeof EmailssentEmailIdStatTypeRoute
  EmailssentEmailIdIndexRoute: typeof EmailssentEmailIdIndexRoute
}

const EmailssentEmailIdRouteRouteChildren: EmailssentEmailIdRouteRouteChildren =
  {
    EmailssentEmailIdStatTypeRoute: EmailssentEmailIdStatTypeRoute,
    EmailssentEmailIdIndexRoute: EmailssentEmailIdIndexRoute,
  }

const EmailssentEmailIdRouteRouteWithChildren =
  EmailssentEmailIdRouteRoute._addFileChildren(
    EmailssentEmailIdRouteRouteChildren,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/campaigns': typeof CampaignsRouteRouteWithChildren
  '/donations': typeof DonationsRouteRouteWithChildren
  '/expenses': typeof ExpensesRouteRouteWithChildren
  '/files': typeof FilesRouteRouteWithChildren
  '/addons': typeof AddonsRoute
  '/contacts/$contactId': typeof ContactsContactIdRouteRouteWithChildren
  '/contacts/fix-and-merge': typeof ContactsFixAndMergeRoute
  '/contacts/task-types': typeof ContactsTaskTypesRoute
  '/contacts/tasks': typeof ContactsTasksRoute
  '/donations/categories': typeof DonationsCategoriesRoute
  '/settings': typeof SettingsLayoutRouteWithChildren
  '/campaigns/': typeof CampaignsIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/donations/': typeof DonationsIndexRoute
  '/expenses/': typeof ExpensesIndexRoute
  '/files/': typeof FilesIndexRoute
  '/emails/$emailId': typeof EmailssentEmailIdRouteRouteWithChildren
  '/contacts/$contactId/edit': typeof ContactsContactIdEditRoute
  '/contacts/$contactId/donations': typeof ContactsContactIdDonationsRoute
  '/contacts/$contactId/emails': typeof ContactsContactIdEmailsRoute
  '/contacts/$contactId/expenses': typeof ContactsContactIdExpensesRoute
  '/contacts/$contactId/files': typeof ContactsContactIdFilesRoute
  '/contacts/groups/$groupId': typeof ContactsGroupsGroupIdRoute
  '/emails/designs/$designId': typeof EmailsDesignsDesignIdRoute
  '/emails/scheduled/$scheduledId': typeof EmailsScheduledScheduledIdRoute
  '/emails/templates/$templateId': typeof EmailsTemplatesTemplateIdRoute
  '/settings/billing': typeof SettingsLayoutBillingRoute
  '/settings/emails': typeof SettingsLayoutEmailsRoute
  '/contacts/$contactId/': typeof ContactsContactIdIndexRoute
  '/contacts/groups': typeof ContactsGroupsIndexRoute
  '/donations/$donationId': typeof DonationsDonationIdIndexRoute
  '/emails': typeof EmailssentIndexRoute
  '/emails/designs': typeof EmailsDesignsIndexRoute
  '/emails/drafts': typeof EmailsDraftsIndexRoute
  '/emails/scheduled': typeof EmailsScheduledIndexRoute
  '/emails/templates': typeof EmailsTemplatesIndexRoute
  '/settings/': typeof SettingsLayoutIndexRoute
  '/emails/$emailId/$statType': typeof EmailssentEmailIdStatTypeRoute
  '/emails/drafts/$draftId/edit': typeof EmailsDraftsDraftIdEditRoute
  '/emails/$emailId/': typeof EmailssentEmailIdIndexRoute
  '/emails/drafts/$draftId': typeof EmailsDraftsDraftIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/addons': typeof AddonsRoute
  '/contacts/fix-and-merge': typeof ContactsFixAndMergeRoute
  '/contacts/task-types': typeof ContactsTaskTypesRoute
  '/contacts/tasks': typeof ContactsTasksRoute
  '/donations/categories': typeof DonationsCategoriesRoute
  '/settings': typeof SettingsLayoutIndexRoute
  '/campaigns': typeof CampaignsIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/donations': typeof DonationsIndexRoute
  '/expenses': typeof ExpensesIndexRoute
  '/files': typeof FilesIndexRoute
  '/contacts/$contactId/edit': typeof ContactsContactIdEditRoute
  '/contacts/$contactId/donations': typeof ContactsContactIdDonationsRoute
  '/contacts/$contactId/emails': typeof ContactsContactIdEmailsRoute
  '/contacts/$contactId/expenses': typeof ContactsContactIdExpensesRoute
  '/contacts/$contactId/files': typeof ContactsContactIdFilesRoute
  '/contacts/groups/$groupId': typeof ContactsGroupsGroupIdRoute
  '/emails/designs/$designId': typeof EmailsDesignsDesignIdRoute
  '/emails/scheduled/$scheduledId': typeof EmailsScheduledScheduledIdRoute
  '/emails/templates/$templateId': typeof EmailsTemplatesTemplateIdRoute
  '/settings/billing': typeof SettingsLayoutBillingRoute
  '/settings/emails': typeof SettingsLayoutEmailsRoute
  '/contacts/$contactId': typeof ContactsContactIdIndexRoute
  '/contacts/groups': typeof ContactsGroupsIndexRoute
  '/donations/$donationId': typeof DonationsDonationIdIndexRoute
  '/emails': typeof EmailssentIndexRoute
  '/emails/designs': typeof EmailsDesignsIndexRoute
  '/emails/drafts': typeof EmailsDraftsIndexRoute
  '/emails/scheduled': typeof EmailsScheduledIndexRoute
  '/emails/templates': typeof EmailsTemplatesIndexRoute
  '/emails/$emailId/$statType': typeof EmailssentEmailIdStatTypeRoute
  '/emails/drafts/$draftId/edit': typeof EmailsDraftsDraftIdEditRoute
  '/emails/$emailId': typeof EmailssentEmailIdIndexRoute
  '/emails/drafts/$draftId': typeof EmailsDraftsDraftIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/campaigns': typeof CampaignsRouteRouteWithChildren
  '/donations': typeof DonationsRouteRouteWithChildren
  '/expenses': typeof ExpensesRouteRouteWithChildren
  '/files': typeof FilesRouteRouteWithChildren
  '/addons': typeof AddonsRoute
  '/contacts/$contactId_': typeof ContactsContactIdRouteRouteWithChildren
  '/contacts/fix-and-merge': typeof ContactsFixAndMergeRoute
  '/contacts/task-types': typeof ContactsTaskTypesRoute
  '/contacts/tasks': typeof ContactsTasksRoute
  '/donations/categories': typeof DonationsCategoriesRoute
  '/settings': typeof SettingsRouteWithChildren
  '/settings/_layout': typeof SettingsLayoutRouteWithChildren
  '/campaigns/': typeof CampaignsIndexRoute
  '/contacts/': typeof ContactsIndexRoute
  '/donations/': typeof DonationsIndexRoute
  '/expenses/': typeof ExpensesIndexRoute
  '/files/': typeof FilesIndexRoute
  '/emails/(sent)/$emailId': typeof EmailssentEmailIdRouteRouteWithChildren
  '/contacts/$contactId/edit': typeof ContactsContactIdEditRoute
  '/contacts/$contactId_/donations': typeof ContactsContactIdDonationsRoute
  '/contacts/$contactId_/emails': typeof ContactsContactIdEmailsRoute
  '/contacts/$contactId_/expenses': typeof ContactsContactIdExpensesRoute
  '/contacts/$contactId_/files': typeof ContactsContactIdFilesRoute
  '/contacts/groups/$groupId': typeof ContactsGroupsGroupIdRoute
  '/emails/designs/$designId': typeof EmailsDesignsDesignIdRoute
  '/emails/scheduled/$scheduledId': typeof EmailsScheduledScheduledIdRoute
  '/emails/templates/$templateId': typeof EmailsTemplatesTemplateIdRoute
  '/settings/_layout/billing': typeof SettingsLayoutBillingRoute
  '/settings/_layout/emails': typeof SettingsLayoutEmailsRoute
  '/contacts/$contactId_/': typeof ContactsContactIdIndexRoute
  '/contacts/groups/': typeof ContactsGroupsIndexRoute
  '/donations/$donationId/': typeof DonationsDonationIdIndexRoute
  '/emails/(sent)/': typeof EmailssentIndexRoute
  '/emails/designs/': typeof EmailsDesignsIndexRoute
  '/emails/drafts/': typeof EmailsDraftsIndexRoute
  '/emails/scheduled/': typeof EmailsScheduledIndexRoute
  '/emails/templates/': typeof EmailsTemplatesIndexRoute
  '/settings/_layout/': typeof SettingsLayoutIndexRoute
  '/emails/(sent)/$emailId/$statType': typeof EmailssentEmailIdStatTypeRoute
  '/emails/drafts/$draftId/edit': typeof EmailsDraftsDraftIdEditRoute
  '/emails/(sent)/$emailId/': typeof EmailssentEmailIdIndexRoute
  '/emails/drafts/$draftId/': typeof EmailsDraftsDraftIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/campaigns'
    | '/donations'
    | '/expenses'
    | '/files'
    | '/addons'
    | '/contacts/$contactId'
    | '/contacts/fix-and-merge'
    | '/contacts/task-types'
    | '/contacts/tasks'
    | '/donations/categories'
    | '/settings'
    | '/campaigns/'
    | '/contacts'
    | '/donations/'
    | '/expenses/'
    | '/files/'
    | '/emails/$emailId'
    | '/contacts/$contactId/edit'
    | '/contacts/$contactId/donations'
    | '/contacts/$contactId/emails'
    | '/contacts/$contactId/expenses'
    | '/contacts/$contactId/files'
    | '/contacts/groups/$groupId'
    | '/emails/designs/$designId'
    | '/emails/scheduled/$scheduledId'
    | '/emails/templates/$templateId'
    | '/settings/billing'
    | '/settings/emails'
    | '/contacts/$contactId/'
    | '/contacts/groups'
    | '/donations/$donationId'
    | '/emails'
    | '/emails/designs'
    | '/emails/drafts'
    | '/emails/scheduled'
    | '/emails/templates'
    | '/settings/'
    | '/emails/$emailId/$statType'
    | '/emails/drafts/$draftId/edit'
    | '/emails/$emailId/'
    | '/emails/drafts/$draftId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/addons'
    | '/contacts/fix-and-merge'
    | '/contacts/task-types'
    | '/contacts/tasks'
    | '/donations/categories'
    | '/settings'
    | '/campaigns'
    | '/contacts'
    | '/donations'
    | '/expenses'
    | '/files'
    | '/contacts/$contactId/edit'
    | '/contacts/$contactId/donations'
    | '/contacts/$contactId/emails'
    | '/contacts/$contactId/expenses'
    | '/contacts/$contactId/files'
    | '/contacts/groups/$groupId'
    | '/emails/designs/$designId'
    | '/emails/scheduled/$scheduledId'
    | '/emails/templates/$templateId'
    | '/settings/billing'
    | '/settings/emails'
    | '/contacts/$contactId'
    | '/contacts/groups'
    | '/donations/$donationId'
    | '/emails'
    | '/emails/designs'
    | '/emails/drafts'
    | '/emails/scheduled'
    | '/emails/templates'
    | '/emails/$emailId/$statType'
    | '/emails/drafts/$draftId/edit'
    | '/emails/$emailId'
    | '/emails/drafts/$draftId'
  id:
    | '__root__'
    | '/'
    | '/campaigns'
    | '/donations'
    | '/expenses'
    | '/files'
    | '/addons'
    | '/contacts/$contactId_'
    | '/contacts/fix-and-merge'
    | '/contacts/task-types'
    | '/contacts/tasks'
    | '/donations/categories'
    | '/settings'
    | '/settings/_layout'
    | '/campaigns/'
    | '/contacts/'
    | '/donations/'
    | '/expenses/'
    | '/files/'
    | '/emails/(sent)/$emailId'
    | '/contacts/$contactId/edit'
    | '/contacts/$contactId_/donations'
    | '/contacts/$contactId_/emails'
    | '/contacts/$contactId_/expenses'
    | '/contacts/$contactId_/files'
    | '/contacts/groups/$groupId'
    | '/emails/designs/$designId'
    | '/emails/scheduled/$scheduledId'
    | '/emails/templates/$templateId'
    | '/settings/_layout/billing'
    | '/settings/_layout/emails'
    | '/contacts/$contactId_/'
    | '/contacts/groups/'
    | '/donations/$donationId/'
    | '/emails/(sent)/'
    | '/emails/designs/'
    | '/emails/drafts/'
    | '/emails/scheduled/'
    | '/emails/templates/'
    | '/settings/_layout/'
    | '/emails/(sent)/$emailId/$statType'
    | '/emails/drafts/$draftId/edit'
    | '/emails/(sent)/$emailId/'
    | '/emails/drafts/$draftId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CampaignsRouteRoute: typeof CampaignsRouteRouteWithChildren
  DonationsRouteRoute: typeof DonationsRouteRouteWithChildren
  ExpensesRouteRoute: typeof ExpensesRouteRouteWithChildren
  FilesRouteRoute: typeof FilesRouteRouteWithChildren
  AddonsRoute: typeof AddonsRoute
  ContactsContactIdRouteRoute: typeof ContactsContactIdRouteRouteWithChildren
  ContactsFixAndMergeRoute: typeof ContactsFixAndMergeRoute
  ContactsTaskTypesRoute: typeof ContactsTaskTypesRoute
  ContactsTasksRoute: typeof ContactsTasksRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  ContactsIndexRoute: typeof ContactsIndexRoute
  EmailssentEmailIdRouteRoute: typeof EmailssentEmailIdRouteRouteWithChildren
  ContactsContactIdEditRoute: typeof ContactsContactIdEditRoute
  ContactsGroupsGroupIdRoute: typeof ContactsGroupsGroupIdRoute
  EmailsDesignsDesignIdRoute: typeof EmailsDesignsDesignIdRoute
  EmailsScheduledScheduledIdRoute: typeof EmailsScheduledScheduledIdRoute
  EmailsTemplatesTemplateIdRoute: typeof EmailsTemplatesTemplateIdRoute
  ContactsGroupsIndexRoute: typeof ContactsGroupsIndexRoute
  EmailssentIndexRoute: typeof EmailssentIndexRoute
  EmailsDesignsIndexRoute: typeof EmailsDesignsIndexRoute
  EmailsDraftsIndexRoute: typeof EmailsDraftsIndexRoute
  EmailsScheduledIndexRoute: typeof EmailsScheduledIndexRoute
  EmailsTemplatesIndexRoute: typeof EmailsTemplatesIndexRoute
  EmailsDraftsDraftIdEditRoute: typeof EmailsDraftsDraftIdEditRoute
  EmailsDraftsDraftIdIndexRoute: typeof EmailsDraftsDraftIdIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CampaignsRouteRoute: CampaignsRouteRouteWithChildren,
  DonationsRouteRoute: DonationsRouteRouteWithChildren,
  ExpensesRouteRoute: ExpensesRouteRouteWithChildren,
  FilesRouteRoute: FilesRouteRouteWithChildren,
  AddonsRoute: AddonsRoute,
  ContactsContactIdRouteRoute: ContactsContactIdRouteRouteWithChildren,
  ContactsFixAndMergeRoute: ContactsFixAndMergeRoute,
  ContactsTaskTypesRoute: ContactsTaskTypesRoute,
  ContactsTasksRoute: ContactsTasksRoute,
  SettingsRoute: SettingsRouteWithChildren,
  ContactsIndexRoute: ContactsIndexRoute,
  EmailssentEmailIdRouteRoute: EmailssentEmailIdRouteRouteWithChildren,
  ContactsContactIdEditRoute: ContactsContactIdEditRoute,
  ContactsGroupsGroupIdRoute: ContactsGroupsGroupIdRoute,
  EmailsDesignsDesignIdRoute: EmailsDesignsDesignIdRoute,
  EmailsScheduledScheduledIdRoute: EmailsScheduledScheduledIdRoute,
  EmailsTemplatesTemplateIdRoute: EmailsTemplatesTemplateIdRoute,
  ContactsGroupsIndexRoute: ContactsGroupsIndexRoute,
  EmailssentIndexRoute: EmailssentIndexRoute,
  EmailsDesignsIndexRoute: EmailsDesignsIndexRoute,
  EmailsDraftsIndexRoute: EmailsDraftsIndexRoute,
  EmailsScheduledIndexRoute: EmailsScheduledIndexRoute,
  EmailsTemplatesIndexRoute: EmailsTemplatesIndexRoute,
  EmailsDraftsDraftIdEditRoute: EmailsDraftsDraftIdEditRoute,
  EmailsDraftsDraftIdIndexRoute: EmailsDraftsDraftIdIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/campaigns",
        "/donations",
        "/expenses",
        "/files",
        "/addons",
        "/contacts/$contactId_",
        "/contacts/fix-and-merge",
        "/contacts/task-types",
        "/contacts/tasks",
        "/settings",
        "/contacts/",
        "/emails/(sent)/$emailId",
        "/contacts/$contactId/edit",
        "/contacts/groups/$groupId",
        "/emails/designs/$designId",
        "/emails/scheduled/$scheduledId",
        "/emails/templates/$templateId",
        "/contacts/groups/",
        "/emails/(sent)/",
        "/emails/designs/",
        "/emails/drafts/",
        "/emails/scheduled/",
        "/emails/templates/",
        "/emails/drafts/$draftId/edit",
        "/emails/drafts/$draftId/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/campaigns": {
      "filePath": "campaigns/route.tsx",
      "children": [
        "/campaigns/"
      ]
    },
    "/donations": {
      "filePath": "donations/route.tsx",
      "children": [
        "/donations/categories",
        "/donations/",
        "/donations/$donationId/"
      ]
    },
    "/expenses": {
      "filePath": "expenses/route.tsx",
      "children": [
        "/expenses/"
      ]
    },
    "/files": {
      "filePath": "files/route.tsx",
      "children": [
        "/files/"
      ]
    },
    "/addons": {
      "filePath": "addons.tsx"
    },
    "/contacts/$contactId_": {
      "filePath": "contacts/$contactId_/route.tsx",
      "children": [
        "/contacts/$contactId_/donations",
        "/contacts/$contactId_/emails",
        "/contacts/$contactId_/expenses",
        "/contacts/$contactId_/files",
        "/contacts/$contactId_/"
      ]
    },
    "/contacts/fix-and-merge": {
      "filePath": "contacts/fix-and-merge.tsx"
    },
    "/contacts/task-types": {
      "filePath": "contacts/task-types.tsx"
    },
    "/contacts/tasks": {
      "filePath": "contacts/tasks.tsx"
    },
    "/donations/categories": {
      "filePath": "donations/categories.tsx",
      "parent": "/donations"
    },
    "/settings": {
      "filePath": "settings",
      "children": [
        "/settings/_layout"
      ]
    },
    "/settings/_layout": {
      "filePath": "settings/_layout.tsx",
      "parent": "/settings",
      "children": [
        "/settings/_layout/billing",
        "/settings/_layout/emails",
        "/settings/_layout/"
      ]
    },
    "/campaigns/": {
      "filePath": "campaigns/index.tsx",
      "parent": "/campaigns"
    },
    "/contacts/": {
      "filePath": "contacts/index.tsx"
    },
    "/donations/": {
      "filePath": "donations/index.tsx",
      "parent": "/donations"
    },
    "/expenses/": {
      "filePath": "expenses/index.tsx",
      "parent": "/expenses"
    },
    "/files/": {
      "filePath": "files/index.tsx",
      "parent": "/files"
    },
    "/emails/(sent)/$emailId": {
      "filePath": "emails/(sent)/$emailId/route.tsx",
      "children": [
        "/emails/(sent)/$emailId/$statType",
        "/emails/(sent)/$emailId/"
      ]
    },
    "/contacts/$contactId/edit": {
      "filePath": "contacts/$contactId.edit.tsx"
    },
    "/contacts/$contactId_/donations": {
      "filePath": "contacts/$contactId_/donations.tsx",
      "parent": "/contacts/$contactId_"
    },
    "/contacts/$contactId_/emails": {
      "filePath": "contacts/$contactId_/emails.tsx",
      "parent": "/contacts/$contactId_"
    },
    "/contacts/$contactId_/expenses": {
      "filePath": "contacts/$contactId_/expenses.tsx",
      "parent": "/contacts/$contactId_"
    },
    "/contacts/$contactId_/files": {
      "filePath": "contacts/$contactId_/files.tsx",
      "parent": "/contacts/$contactId_"
    },
    "/contacts/groups/$groupId": {
      "filePath": "contacts/groups/$groupId.tsx"
    },
    "/emails/designs/$designId": {
      "filePath": "emails/designs/$designId.tsx"
    },
    "/emails/scheduled/$scheduledId": {
      "filePath": "emails/scheduled/$scheduledId.tsx"
    },
    "/emails/templates/$templateId": {
      "filePath": "emails/templates/$templateId.tsx"
    },
    "/settings/_layout/billing": {
      "filePath": "settings/_layout.billing.tsx",
      "parent": "/settings/_layout"
    },
    "/settings/_layout/emails": {
      "filePath": "settings/_layout.emails.tsx",
      "parent": "/settings/_layout"
    },
    "/contacts/$contactId_/": {
      "filePath": "contacts/$contactId_/index.tsx",
      "parent": "/contacts/$contactId_"
    },
    "/contacts/groups/": {
      "filePath": "contacts/groups/index.tsx"
    },
    "/donations/$donationId/": {
      "filePath": "donations/$donationId/index.tsx",
      "parent": "/donations"
    },
    "/emails/(sent)/": {
      "filePath": "emails/(sent)/index.tsx"
    },
    "/emails/designs/": {
      "filePath": "emails/designs/index.tsx"
    },
    "/emails/drafts/": {
      "filePath": "emails/drafts/index.tsx"
    },
    "/emails/scheduled/": {
      "filePath": "emails/scheduled/index.tsx"
    },
    "/emails/templates/": {
      "filePath": "emails/templates/index.tsx"
    },
    "/settings/_layout/": {
      "filePath": "settings/_layout.index.tsx",
      "parent": "/settings/_layout"
    },
    "/emails/(sent)/$emailId/$statType": {
      "filePath": "emails/(sent)/$emailId/$statType.tsx",
      "parent": "/emails/(sent)/$emailId"
    },
    "/emails/drafts/$draftId/edit": {
      "filePath": "emails/drafts/$draftId/edit.tsx"
    },
    "/emails/(sent)/$emailId/": {
      "filePath": "emails/(sent)/$emailId/index.tsx",
      "parent": "/emails/(sent)/$emailId"
    },
    "/emails/drafts/$draftId/": {
      "filePath": "emails/drafts/$draftId/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
